import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41c10d30")

_pushScopeId("data-v-41c10d30")
const _hoisted_1 = { class: "p-input-icon-left p-mb-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = {
  class: "p-d-flex p-ai-center p-jc-between",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "p-text-right" }
const _hoisted_5 = {
  key: 0,
  class: "validating"
}
const _hoisted_6 = { style: {"width":"100%"} }
const _hoisted_7 = { style: {"width":"100%"} }
const _hoisted_8 = { class: "p-d-flex p-jc-center p-ai-center" }
const _hoisted_9 = {
  key: 0,
  class: "p-mt-4"
}
const _hoisted_10 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_11 = {
  key: 1,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_12 = {
  key: 1,
  class: "p-mt-4",
  style: {"height":"5vh"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _ctx.search_key,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search_key = $event)),
        placeholder: _ctx.$t('label.search'),
        onKeyup: _ctx.loadDatasourceByName,
        style: {"width":"25rem"}
      }, null, 8, ["modelValue", "placeholder", "onKeyup"])
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.datasources,
      selection: _ctx.selectedDatasource,
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDatasource = $event)),
      selectionMode: "single",
      responsiveLayout: "scroll",
      onRowSelect: _ctx.onRowSelect,
      onSort: _ctx.onSort,
      scrollable: true,
      scrollHeight: "70vh",
      frozen: "true",
      rowClass: () => 'row-class',
      class: "p-datatable-sm"
    }, _createSlots({
      default: _withId(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('upload.datasource.name'),
          sortable: true,
          style: {"min-width":"16rem"}
        }, {
          body: _withId((slotProps) => [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", {
                class: {
              'p-text-truncate': _ctx.displayButton === slotProps.data.id,
            }
              }, _toDisplayString(slotProps.data.name), 3)
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, { style: {"min-width":"8rem"} }, {
          body: _withId((slotProps) => [
            _createVNode("div", _hoisted_4, [
              (slotProps.data.status === 'INITIAL')
                ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("autots.label.validating")), 1))
                : _createCommentVNode("", true),
              (
              slotProps.data.status === 'READY' &&
              _ctx.displayButton === slotProps.data.id
            )
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "#",
                    label: _ctx.$t('autots.label.select.as.datasource'),
                    class: "p-button-link select-button",
                    onClick: ($event: any) => (_ctx.handleSelectDs(slotProps))
                  }, _toDisplayString(_ctx.$t("autots.label.select.as.datasource")), 9, ["label", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: _ctx.$t('autots.label.createdby')
        }, {
          body: _withId((slotProps) => [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.getFullname(slotProps.data.createdBy)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "lastModifiedDate",
          header: _ctx.$t('autots.label.createddate'),
          sortable: true
        }, {
          body: _withId((slotProps) => [
            _withDirectives(_createVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$moment(slotProps.data.createdDate).fromNow()), 1)
            ], 512), [
              [_directive_tooltip, 
            _ctx.$moment(slotProps.data.createdDate).format('YYYY-MM-DD HH:mm:ss')
          ]
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 2
    }, [
      (_ctx.datasources && _ctx.datasources.length == 0)
        ? {
            name: "footer",
            fn: _withId(() => [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("datasource.list-datasource.table.empty")), 1)
            ])
          }
        : undefined
    ]), 1032, ["value", "selection", "onRowSelect", "onSort", "rowClass"]),
    (_ctx.hasMoreDatasource() || _ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          (!_ctx.loading && _ctx.hasMoreDatasource())
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('button.more'),
                  class: "p-button-text",
                  onClick: _ctx.loadMoreDatasource,
                  icon: "pi pi-chevron-down",
                  iconPos: "right"
                }, null, 8, ["label", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode(_component_ProgressSpinner, {
                  class: "file-progress-spinner",
                  strokeWidth: "3",
                  animationDuration: ".5s",
                  style: {"width":"24px","height":"24px"}
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_12))
  ], 64))
})